package com.neurobs.react

import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html.{className, key, table, tbody, td, tr}

/** Row of a FormTable */
@react object FormTableRow {
	case class Props(left: ReactElement, right: ReactElement)

	val component = FunctionalComponent[Props] { props =>
		tr(
			td(key := "left", className := formTableLeftColumnClass, props.left),
			td(key := "right", className := formTableRightColumnClass, props.right)
		)
	}

	private val formTableLeftColumnClass = "structure-form-table-left-column"
	private val formTableRightColumnClass = "structure-form-table-right-column"
}

/** 2-column table with the left column right-justified, and the right column left-justified */
@react object FormTable {
	case class Props(children: ReactElement*)

	val component = FunctionalComponent[Props] { props =>
		table(className := formTableClass)(tbody(props.children))
	}

	private val formTableClass = "structure-form-table"
}
